module.exports = __webpack_public_path__ + "img/bg1280.4a7bfe0f.png";